require('/opt/odin/app/frontend/components/practice_test_banner/index.module.scss');module.exports = "../../app/cells/components/practice_test_banner/show.erb";